import { GeneralContext } from '@f_context/General_context';
import { useWindowSize } from '@f_hooks/index';
import { useMigratedUserLock } from '@f_hooks/useMigratedUserLock';
import { Assistant } from '@f_qwep/components/assistant/Assistant';
import { MigratedNoticePage } from '@f_qwep/components/migrated/MigratedNoticePage';
import { Info } from '@f_qwep/components/info';
import { SearchResult } from '@f_qwep/components/searchResult';
import { QwepProviders } from '@f_qwep/context';
import { ProtectedRoute } from '@f_qwep/general/ProtectedRoute';
import '@f_qwep/styles/baseQwep.sass';
import stls from '@f_qwep/styles/general/AppQwep.module.sass';
import { QwepProductEnum } from '@f_qwep/types/QwepProductEnum.type';
import { useContext, useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ErrorBoundaryComponent } from '../../general/pageError/PageError';
import { IndexBasket } from './components/basket';
import { BatchPricer } from './components/batchPricer';
import { MyAcconts } from './components/group/MyAccounts';
import { HeaderComponent } from './components/header';
import { TariffIcon } from './components/header/TariffIcon';
import { Subscription } from './components/licenses/Subscription';
import { Manual } from './components/manual/Manual';
import Navbar from './components/navbar';
import { IndexOrders } from './components/orders';
import { Prices } from './components/prices';
import { Search } from './components/search';
import { SearchItems } from './components/searchItems';
import AddBasketModal from './components/searchResult/AddBasketModal';
import CardResult from './components/searchResult/CardResult';
import { Settings } from './components/settings';
import { Congratulation } from './general/Congratulation';
import { ExportExcelModal } from './general/ExportExcelModal';

export function AppQwep() {
    const baseRedirectPath = '/app-qwep';
    const { reloadQwep, drawerPanels } = useContext(GeneralContext);
    const { isMigratedLocked, panelsReady } = useMigratedUserLock(drawerPanels);

    const [loading, setLoading] = useState(false);
    const [mobile, setMobile] = useState(false);

    const { width } = useWindowSize();

    useEffect(() => {
        setMobile(width < 480);
    }, [width]);

    useEffect(() => {
        if (reloadQwep) {
            setLoading(true);
        } else {
            setLoading(false);
        }
    }, [reloadQwep]);

    if (panelsReady && isMigratedLocked) {
        return (
            <ErrorBoundary fallbackRender={() => <ErrorBoundaryComponent app={'Qwep'} />}>
                <QwepProviders>
                    <div className={stls.general}>
                        <Routes>
                            <Route path="migrated" element={<MigratedNoticePage />} />
                            <Route path="*" element={<Navigate to="/app-qwep/migrated" replace />} />
                        </Routes>
                    </div>
                </QwepProviders>
            </ErrorBoundary>
        );
    }

    return (
        <>
            {loading ? (
                <></>
            ) : (
                <ErrorBoundary fallbackRender={() => <ErrorBoundaryComponent app={'Qwep'} />}>
                    <QwepProviders>
                        <div className={stls.general}>
                            <TariffIcon />
                            <HeaderComponent />
                            <Search />
                            <Navbar />
                            <Routes>
                                <Route path={'/'} element={<Info />} />
                                <Route path={'search'} element={<SearchResult />} />
                                <Route path={'search/items'} element={<SearchItems />} />
                                <Route path={'settings/accounts'} element={<MyAcconts />} />
                                <Route
                                    path={'prices'}
                                    element={
                                        <ProtectedRoute redirectPath={baseRedirectPath} product={QwepProductEnum.PRICE}>
                                            <Prices />
                                        </ProtectedRoute>
                                    }
                                />
                                {/* <Route path={'prices'} element={<MaintenancePage />} /> */}
                                <Route path={'settings'} element={<Settings />} />
                                <Route
                                    path={'basket'}
                                    element={
                                        <ProtectedRoute
                                            redirectPath={baseRedirectPath}
                                            product={QwepProductEnum.BASKET}>
                                            <IndexBasket />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path={'orders'}
                                    element={
                                        <ProtectedRoute
                                            redirectPath={baseRedirectPath}
                                            product={QwepProductEnum.ORDERS}>
                                            <IndexOrders />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route path={'batch-pricer'} element={<BatchPricer />} />
                                {/* <Route path={'batch-pricer'} element={<MaintenancePage />} /> */}

                                <Route path={'subscription'} element={<Subscription />} />
                                <Route path={'purchasing-assistant'} element={<Assistant />} />
                            </Routes>
                            <AddBasketModal />
                            <CardResult />
                            <ExportExcelModal />
                            {/* <WidgetInfo/> */}

                            <Congratulation />
                        </div>

                        <Manual />
                    </QwepProviders>
                </ErrorBoundary>
            )}
        </>
    );
}
